<template>
<header class="header-wrapper">
  <div class="overlay-menu" v-if="menuIconClicked">
    <nav role="navigation" class="nav-links">
      <a href="/hybrid-teams" class="anchor-link">For hybrid teams</a>
      <div class="use-case-wrapper jobs-dropdown-wrapper">
        <div class="use-case-label jobs-dropdown-label usecase" @click="useCaseClick">
          <div class="label" v-bind:class="{'open': useCaseClicked}">Use cases</div>
          <img class="arrow" src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/609a29a719cd3e2e7accd635_arrow-grey.svg" alt="Dropdown Arrow">
        </div>
        <nav class="use-case-nav-list jobs-dropdown-nav-list" v-bind:class="{'open': useCaseClicked}">
          <a class="list-item" href="/flexible-working">Flexible working</a>
          <a class="list-item" href="/team-location-schedule">Team location schedule</a>
          <a class="list-item" href="/hybrid-meetings">Hybrid meetings</a>
          <a class="list-item" href="/team-visibility">Team visibility</a>
        </nav>
      </div>
      <div class="about-wrapper jobs-dropdown-wrapper">
        <div class="about-label jobs-dropdown-label" @click="aboutClick">
          <div class="label" v-bind:class="{'open': aboutClicked}">About</div>
          <img class="arrow" src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/609a29a719cd3e2e7accd635_arrow-grey.svg" alt="Dropdown Arrow">
        </div>
        <nav class="about-nav-list jobs-dropdown-nav-list" v-bind:class="{'open': aboutClicked}">
          <div class="up-arrow"></div>
          <a class="list-item" href="/about-us">About us</a>
          <a class="list-item" href="/blog">Blog</a>
        </nav>
      </div>
      <a href="/job-share" class="anchor-link">Job share</a>
      <div class="sign-in-container">
        <a href="https://app.duome.co" class="">Sign up</a>
      </div>
    </nav>
    <div class="overlay-menu-scrim jobs-scrim" v-if="menuIconClicked" @click="closeMenu('menuicon')"></div>
  </div>
  <div class="header-container">
    <a href="/" class="logo-link">
      <img src="../src/assets/duome-logo-blacklogo.svg" />
    </a>
    <div class="jobs-nav-menu-wrapper">
      <nav role="navigation" class="nav-links adjust-links">
        <a href="/hybrid-teams" class="anchor-link">For hybrid teams</a>
        <div class="use-case-wrapper jobs-dropdown-wrapper">
          <div class="use-case-label jobs-dropdown-label usecase" @click="useCaseClick">
            <div class="usecase">Use cases</div>
            <img class="usecase" src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/604206385c05bf66780f111c_dropdown-arrow-black.svg" alt="Dropdown Arrow">
          </div>
          <nav class="use-case-nav-list jobs-dropdown-nav-list" v-bind:class="{'open': useCaseClicked}">
            <div class="up-arrow"></div>
            <a class="list-item" href="/flexible-working">Flexible working</a>
            <a class="list-item" href="/team-location-schedule">Team location schedule</a>
            <a class="list-item" href="/hybrid-meetings">Hybrid meetings</a>
            <a class="list-item" href="/team-visibility">Team visibility</a>
          </nav>
          <div class="usecase-scrim jobs-scrim" v-if="useCaseClicked" @click="closeMenu('usecase')"></div>
        </div>
        <div class="about-wrapper jobs-dropdown-wrapper">
          <div class="about-label jobs-dropdown-label" @click="aboutClick">
            <div>About</div>
            <img src="https://uploads-ssl.webflow.com/604206385c05bfc8a50f104b/604206385c05bf66780f111c_dropdown-arrow-black.svg" alt="Dropdown Arrow">
          </div>
          <nav class="about-nav-list jobs-dropdown-nav-list" v-bind:class="{'open': aboutClicked}">
            <div class="up-arrow"></div>
            <a class="list-item" href="/about-us">About us</a>
            <a class="list-item" href="/blog">Blog</a>
          </nav>
          <div class="about-scrim jobs-scrim" v-if="aboutClicked" @click="closeMenu('about')"></div>
        </div>
        <a href="/job-share" class="anchor-link">Job share</a>
      </nav>
      <div class="sign-in-container">
        <a href="https://app.duome.co" class="adjust-links">Sign up</a>
        <div class="menu-icon"><img src="../src/assets/icon-menu.svg" alt="" @click="menuIconClick"></div>
      </div>
    </div>
  </div>
</header>
</template>

<script>
export default {
  data () {
    return {
      useCaseClicked: false,
      aboutClicked: false,
      menuIconClicked: false
    }
  },
  mounted () {
  },
  methods: {
    menuIconClick () {
      this.menuIconClicked = !this.menuIconClicked
    },
    closeMenu (type) {
      if (type) {
        switch (type) {
          case 'usecase':
            this.useCaseClicked = false
            return
          case 'about':
            this.aboutClicked = false
            return
          case 'menuicon': 
            this.menuIconClicked = false
            return
          default:
            return
        }
      }
      return
    },
    useCaseClick () {
      this.aboutClicked = false
      this.useCaseClicked = !this.useCaseClicked
    },
    aboutClick () {
      this.useCaseClicked = false
      this.aboutClicked = !this.aboutClicked
    }
  },
  watch: {
    useCaseClicked: {
      handler () {
      }
    }
  }
}
</script>

<style>
.header-wrapper {
  position: sticky;
  left: 0;
  top: 0;
  right: 0;
  bottom: auto;
  height: 80px;
  border-bottom: 1px solid;
  border-color: rgba(163,162,160,0) rgba(163,162,160,0) rgba(163,162,160,.2);
  border-radius: 0;
  background-color: #fff;
  width: 100%;
  z-index: 11;
  display: flex;
  align-items: center;
  font-family: 'Nunito Sans';
}
.header-wrapper .header-container {
  position: relative;
  width: 100%;
  max-width: 1296px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  grid-template-rows: auto;
  border-bottom: 1px #000;
  grid-template-columns: 1fr 1.5fr 1fr;
  align-items: center;
  grid-auto-columns: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  justify-content: space-between;
}
.header-wrapper a.logo-link {
  position: relative;
  float: left;
  text-decoration: none;
  color: #333;
  display: flex;
  margin: 12px 18px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.header-wrapper a img {
  max-height: 40px;
  min-height: auto;
  min-width: auto;
}
.jobs-nav-menu-wrapper {
  display: flex;
  white-space: nowrap;
}
.jobs-nav-menu-wrapper nav {
  display: flex;
  align-items: center;
  position: relative;
  float: right;
}
.jobs-nav-menu-wrapper nav .anchor-link {
  background-color: transparent;
  color: #141414;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  margin-right: 12px;
  margin-left: 12px;
  transition: opacity .2s;
  text-decoration: none;
  background: transparent;
  line-height: 25px;
}
.jobs-dropdown-wrapper {
  padding: 3px 0;
  transition: color .2s;
  color: #141414;
  cursor: pointer;
  display: inline-block;
  position: relative;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  z-index: 900;
}
.jobs-scrim {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  cursor: default;
}
.jobs-dropdown-wrapper .jobs-dropdown-label {
  display: flex;
  margin-right: 12px;
  margin-left: 12px;
  padding: 0;
  align-items: center;
  transition: opacity .2s;
  cursor: pointer;
  position: relative;
  vertical-align: top;
  text-decoration: none;
  color: #222;
  text-align: left;
  white-space: nowrap;
  font-weight: 600;
}
.jobs-dropdown-wrapper .jobs-dropdown-label img {
  margin-left: 6px;
  border: 0;
  vertical-align: middle;
  display: inline-block;
  max-width: 100%;
}
nav.jobs-dropdown-nav-list {
  position: absolute;
  background: #f8f8f8;
  display: none;
  min-width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  flex-direction: column;
}
nav.jobs-dropdown-nav-list.open {
  display: block;
  min-width: 200px;
  margin-left: 12px;
  padding: 18px 24px;
  background-color: #fff;
  box-shadow: 0 6px 20px -4px rgb(0 0 0 / 25%);
  transform: translate(-40%,6px);
  z-index: 5;
}
nav.jobs-dropdown-nav-list .up-arrow {
  position: absolute;
  left: 50%;
  top: -4px;
  right: 50%;
  width: 12px;
  height: 12px;
  background-color: #fff;
  transform: translate(-50%,0) rotate(45deg);
}
nav.jobs-dropdown-nav-list .list-item {
    padding: 3px 0;
    transition: color .2s;
    color: rgba(20,20,20,.5);
    cursor: pointer;
    position: relative;
    text-decoration: none;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    white-space: nowrap;
    display: block;
}
nav.jobs-dropdown-nav-list .list-item:hover {
  color: #141414;
  outline: 0;
}
.sign-in-container {
  display: flex;
  align-items: center;
  z-index: 900;
  padding: 12px 0;
}
.sign-in-container a {
  border: 1px solid transparent;
  background-color: transparent;
  transition-property: none;
  color: #e00a16;
  font-weight: 900;
  padding: 12px 24px;
  text-decoration: none;
}
.sign-in-container a:hover {
  border-style: solid;
  border-color: #e00a16;
  box-shadow: none;
  border-radius: 6px;
}
.sign-in-container .menu-icon {
  display: none;
}
.overlay-menu .sign-in-container a {
  padding: 0;
}
@media (max-width: 479px) {
  .header-wrapper a.logo-link {
    margin-left: 0;
  }
  .header-wrapper a img {
    max-height: 34px;
  }
}
@media (max-width: 767px) {
  .header-wrapper a.logo-link {
    margin-left: 0;
  }
}
@media (max-width: 990px) {
  .adjust-links {
    display: none !important;
  }
  .sign-in-container .menu-icon {
    display: block;
    cursor: pointer;
  }
  .overlay-menu .sign-in-container a {
    padding: 0;
  }
  .overlay-menu .sign-in-container a:hover {
    border-style: solid;
    border-color: transparent;
    box-shadow: none;
    border-radius: 0;
  }
  .header-wrapper .header-container {
    display: flex;
  }
}

.header-wrapper .overlay-menu {
  display: block;
  position: absolute;
  overflow: hidden;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  z-index: 7;
}
.header-wrapper .overlay-menu nav .anchor-link {
  z-index: 900;
  color: #15171a;
  text-decoration: none;
  line-height: 25px;
  padding: 18px 0;
  font-weight: 600;
}
.header-wrapper .overlay-menu > nav {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 0 24px 24px 24px;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-wrapper,
.header-wrapper .overlay-menu nav .jobs-dropdown-label,
.header-wrapper .overlay-menu nav .list-item {
  margin: 0;
  padding: 0;
  width: 100%;
}
.header-wrapper .overlay-menu nav .list-item {
  padding: 12px;
  font-weight: 600;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-label {
  justify-content: space-between;
  padding: 18px 0;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-label .label.open {
  font-weight: 900;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-label img {
  height: 21px;
  width: 43px;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-nav-list {
  padding-top: 6px;
  padding-bottom: 6px;
  flex-direction: column;
}
.header-wrapper .overlay-menu nav .jobs-dropdown-nav-list.open {
  display: flex;
  position: relative;
  background-color: transparent;
  box-shadow: none;
  transform: none;
  border-top: 1px solid rgba(70,88,107,.13);
  border-bottom: 1px solid rgba(70,88,107,.13);
  margin: 0;
  padding: 6px;
}
</style>



